import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { VehicleService } from '../vehicle.service';

@Component({
  selector: 'app-vehicle-dialog',
  templateUrl: './vehicle-dialog.component.html',
  styleUrls: ['./vehicle-dialog.component.scss']
})
export class VehicleDialogComponent {
  form: FormGroup;
  loading = false;
  isEdit = false;

  constructor(
    private fb: FormBuilder,
    private vehicleService: VehicleService,
    private dialogRef: MatDialogRef<VehicleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEdit = !!data;
    this.form = this.fb.group({
      plateNumber: [data?.plateNumber || '', Validators.required],
      model: [data?.model || '', Validators.required],
      type: [data?.type || '', Validators.required],
      capacity: [data?.capacity || '', Validators.required],
      isActive: [data?.isActive ?? true] // only used for update; ignored on create
    });
  }

  onSave(): void {
    if (this.form.invalid) {
      Swal.fire('Validation', 'Please fill all required fields', 'warning');
      return;
    }

    this.loading = true;

    if (this.isEdit) {
      console.log('[VehicleDialog] ✏️ Update payload:', this.form.value);
      this.vehicleService.updateVehicle(this.data.id, this.form.value).subscribe({
        next: () => {
          this.loading = false;
          Swal.fire('Success', 'Vehicle updated successfully', 'success');
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.loading = false;
          console.error('[VehicleDialog] ❌ Error updating vehicle:', err);
          Swal.fire('Error', 'Failed to update vehicle', 'error');
        }
      });
    } else {
      // Create — send only fields required by CreateVehicleDto
      const payload = {
        plateNumber: this.form.value.plateNumber,
        model: this.form.value.model,
        type: this.form.value.type,
        capacity: String(this.form.value.capacity)
      };
      console.log('[VehicleDialog] ➕ Create payload:', payload);

      this.vehicleService.createVehicle(payload).subscribe({
        next: () => {
          this.loading = false;
          Swal.fire('Success', 'Vehicle created successfully', 'success');
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.loading = false;
          console.error('[VehicleDialog] ❌ Error saving vehicle:', err);
          Swal.fire('Error', 'Failed to save vehicle', 'error');
        }
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
